<template>
    <div>
        <loading :loading="isLoading"></loading>
        <div v-if="upgrading">
            <div v-if="isIos || isAndroid">
                <UpgradeDevice :on-cancel="cancelUpgrade" :on-success="hasUpgraded"></UpgradeDevice>
            </div>
            <div v-else>
                <UpgradeComp :on-cancel="cancelUpgrade" :on-success="hasUpgraded"></UpgradeComp>
            </div>
        </div>
        <div class="row justify-content-center" v-else>
            <div class="col-12 col-xs-12 col-md-6">
                <div class="u-form u-mt1">
                    <h3>Send A Message</h3>
                    <ion-label>Give your message a title</ion-label>
                    <ion-input placeholder="Title" type="text" shape="round" expand="full" :value="title" v-on:ionInput="setTitle($event)" style='background:var(--ion-color-light); border-radius: 20px; margin-bottom: 12px; text-align: left; --padding-start: 20px'></ion-input>

                    <ion-label>When should we send it?</ion-label>
                    <div v-if="isIos">
                        <!-- date input -->
                        <input type="date" :min="today" placeholder="Select a date" class="d-picker" v-model="send_at">
                    </div>
                    <div v-else>
                        <!-- datepicker -->
                        <datepicker
                            :disabled-dates="dpickerDisabled"
                            placeholder="Select a date"
                            input-class="d-picker"
                            calendar-class="ghost-calendar"
                            v-model="send_at_date"></datepicker>
                    </div>

                    <ion-label>What type of message?</ion-label>
                    <ion-select placeholder="Select One" v-on:ionChange="setType($event)" :value="type">
                        <ion-select-option  v-for="(t, i) in types" v-bind:key="i" :value="i" :selected-text="t">
                            {{t}}
                        </ion-select-option>
                    </ion-select>

                    <!-- message -->
                    <div v-if="type=='text'">
                        <ion-label>Your Message</ion-label>
                        <ion-textarea placeholder="Your Message" :value="message" rows="6" type="text" shape="round" expand="full" v-on:ionInput="setMessage($event)" style='background:var(--ion-color-light); border-radius: 20px; margin-bottom: 12px; text-align: left; --padding-start: 20px'></ion-textarea>
                    </div>
                    <div v-if="type=='audio'">
                        <audio-upload :clear-media="clearMedia" :set-media="setMedia" :media="media" :thumbnail="thumbnail"></audio-upload>
                    </div>
                    <div v-if="type=='video'">
                        <video-upload :clear-media="clearMedia" :set-media="setMedia" :media="media" :thumbnail="thumbnail"></video-upload>
                    </div>
                    <div v-if="type=='image'">
                        <image-upload :clear-media="clearMedia" :set-media="setMedia" :media="media" :thumbnail="thumbnail"></image-upload>
                    </div>

                    <!-- recipients -->
                    <ion-label>Who do you want to see it?</ion-label>
                    <ion-select multiple="true" placeholder="Select Recipients" v-if="hasContacts" v-on:ionChange="setRecipients($event)">
                        <ion-select-option v-for="contact in contacts" :value="contact.id" v-bind:key="contact.id" :selected-text="contact.name">
                            {{contact.name}} - {{contact.email}}
                        </ion-select-option>
                        <ion-select-option :value="0" selected-text="New Recipient">
                            Add a new recipient
                        </ion-select-option>
                    </ion-select>
                    <div v-if="!hasContacts || newContact">
                        <ion-label>Add a new recipient</ion-label>
                        <ion-input placeholder="Name" type="text" shape="round" v-on:ionInput="setRecipientName($event)" expand="full" style='background:var(--ion-color-light); border-radius: 20px; margin-bottom: 12px; text-align: left; --padding-start: 20px'></ion-input>
                        <ion-input placeholder="Email Address" type="email" shape="round" v-on:ionInput="setRecipientEmail($event)" expand="full" style='background:var(--ion-color-light); border-radius: 20px; margin-bottom: 12px; text-align: left; --padding-start: 20px'></ion-input>
                    </div>
                    <div v-if="uploading">
                        <div class="progress">
                            <div class="progress-bar bg-primary" role="progressbar" :style="'width: '+ percent + '%'">
                                Uploading : {{percent}}%
                            </div>
                        </div>
                        <div class="media-info" v-if="preparing">
                            <i class="fas fa-circle-notch fa-spin spinner"></i>
                            Please wait - preparing {{media.size | fileSize}} for upload.
                        </div>
                        <div class="media-info" v-else>
                            Uploading {{media.size | fileSize}}
                        </div>
                    </div>
                    <div v-else-if="posting" class="media-info">
                        <i class="fas fa-circle-notch fa-spin spinner"></i>
                    </div>
                    <div v-else>
                        <ion-button shape="round" expand="full" v-on:click="sendMessage()" :disabled="!canSend">Send Message</ion-button>
                    </div>
                </div>
            </div>
        </div>
        <return-home />
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
import _ from 'lodash';
import ReturnHome from '@/components/ReturnHome.vue';
import AudioUpload from '@/components/recorders/Audio.vue';
import ImageUpload from '@/components/recorders/Image.vue';
import VideoUpload from '@/components/recorders/Video.vue';
import Loading from '@/components/Loading.vue';
import Upgrade from '@/components/Upgrade.vue';
import UpgradeDevice from "@/components/UpgradeDevice.vue";
import {auth} from '@/mixins/auth';
import {device} from '@/mixins/device';
import {userdetails} from '@/mixins/userdetails';
import {alerts} from '@/mixins/alerts';
import {formatting} from '@/mixins/formatting';

export default {
    name: 'send',
    mounted : function () {
        this.checkSpace();
        this.getContacts();
    },
    data : function () {
        let send_at = moment().endOf('year').add(1, 'day');

        return {
            media        : null,
            mediaUrl     : '',
            title        : '',
            message      : '',
            contacts     : [],
            recipients   : [],
            newRecipient : {
                name : '',
                email : ''
            },
            currentChunk : 0,
            chunks : [],
            uploading : false,
            posting : false,
            send_at : send_at.format('YYYY-MM-DD'),
            send_at_date : send_at.toDate(),
            newContact : false,
            loaded : {
                contacts : false,
                space    : false,
                media    : true
            },
            space : {
                available : 0,
                purchased : 0,
                used      : 0
            },
            bytesSent   : 0,
            bytesToSend : 0,
            chunkSize   : 600000,
            chunkCount  : 0,
            percent     : 0,
            preparing   : false,
            thumbnail   : null,
            errorCount  : 0,
            upgrading   : false,
            dpickerDisabled : {
                to : moment().add(1, 'day').toDate(),
                from : moment('2080-01-01').toDate()
            }
        }
    },
    components: {
        ReturnHome, Loading, AudioUpload, VideoUpload, ImageUpload, Datepicker,
        UpgradeComp: Upgrade,
        UpgradeDevice
    },
    watch : {
        media : function (val) {
            console.debug('MEDIA CHANGED', Date.now(), this.type, this.media);
        },
        thumbnail : function (val) {
            console.debug('THUMBNAIL', Date.now(), this.thumbnail);
        },
        preparing : function (val) {
            console.debug('PREPARING', Date.now(), this.preparing);
        },
        uploading : function (val) {
            console.debug('UPLOADING', Date.now(), this.uploading);
        },
        send_at_date : function (val) {
            let m_val   = moment(val),
                new_val = m_val.format('YYYY-MM-DD'),
                s_date  = moment(this.send_at).format('YYYY-MM-DD');
            if (m_val.isValid() && new_val !== s_date) {
                this.send_at = new_val;
            }
        },
        send_at : function (val) {
            let m_val   = moment(val),
                new_val = m_val.format('YYYY-MM-DD'),
                sa_date = moment(this.send_at_date).format('YYYY-MM-DD');
            if (m_val.isValid() && new_val !== sa_date) {
                this.send_at_date = moment(val).toDate();
            }
        }
    },
    computed : {
        isLoading : function () {
            return !this.loaded.contacts || !this.loaded.space || !this.loaded.media;
        },
        today : function () {
            return moment().add(1, 'day').format('YYYY-MM-DD');
        },
        hasContacts : function () {
            return _.size(this.contacts) > 0;
        },
        types : function () {
            return {
                text  : 'Text',
                image : 'Photo',
                audio : 'Call',
                video : 'Video'
            };
        },
        canSend : function () {
            if (this.type == '' || _.trim(this.title) == '') {
                return false;
            }

            if (this.type == 'text') {
                return _.trim(this.message) != '';
            } else {
                return this.media != null;
            }

            if (_.size(this.recipients) == 0) {
                if (this.newRecipient.name == '' || this.newRecipient.email == '') {
                    return false;
                }
            } else {
                var newRecipient = _.find(this.recipients, function (recipient) {
                    return recipient == 0;
                });
                if (newRecipient) {
                    if (this.newRecipient.name == '' || this.newRecipient.email == '') {
                        return false;
                    }
                }
            }
            return true;
        }
    },
    mixins : [auth, userdetails, alerts, formatting, device],
    methods : {
        mediaUploading : function () {
            this.loaded.media = false;
        },
        mediaUploaded : function () {
            this.loaded.media = true;
        },
        getDataUrlFromPath : function (path) {
            let self = this;
            this.mediaUploading();
            window.resolveLocalFileSystemURL(path, function(fileEntry) {
                return fileEntry.file(function(data) {
                    var reader = new FileReader();
                    reader.onloadend = function(e) {
                        var base64data = reader.result;
                    };
                    return reader.readAsDataURL(data);
                });
            });
        },
        getDataUrl : function (mediaFile) {
            this.getDataUrlFromPath(mediaFile.fullPath);
        },
        checkSpace : function () {
            let self = this;
            this.loaded.space = false;
            this.axios.get(this.api + 'users/space')
                .then(response => {
                    self.space = response.data;
                    self.loaded.space = true;
                    if (self.space.purchased == 0) {
                        self.showError('You will need to upgrade before you can send any messages');
                    } else if (self.space.available < 2000000) {
                        self.showError('You have used most of your space allowance.  You may need to upgrade before you can upload videos, calls, or photos');
                    }
                })
                .catch(error => {
                    console.error('error setting space', error);
                });
        },
        getImageThumbnail : function () {
            let self = this;
            let file = this.media;

            var reader = new FileReader();
            // Set the image once loaded into file reader
            reader.onload = function(e) {
                self.thumbnail = e.target.result; // set the thumbnail
            }
            reader.readAsDataURL(file);
        },
        setMedia : function (media) {
            this.thumbnail = null;
            this.media = media;
            this.thumbnail = '/img/icons/' + this.type + '-thumb-icon.png';
            if (this.type == 'image') {
                this.getImageThumbnail();
            }
            this.mediaUploaded();
        },
        clearMedia : function () {
            this.media = null;
            this.thumbnail = null;
        },
        getContacts : function () {
            let self = this;
            this.loaded.contacts = false;
            this.axios.get(this.api + 'contacts')
                .then(response => {
                    self.contacts = response.data;
                    self.loaded.contacts = true;
                })
                .catch(error => {
                    console.error('Could not get contacts', error);
                })
        },
        setTitle : function (event) {
            this.title = event.target.value;
        },
        setMessage : function (event) {
            this.message = event.target.value;
        },
        setType : function (event) {
            if (this.type != event.target.value) {
                this.media = null;
            }
            this.type = event.target.value;
        },
        setDate : function (event) {
            console.log('event', event);
            console.log(event.details.value);
            var date = moment();
            date.year(event.detail.value.year.value);
            date.month(event.detail.value.month.value - 1);
            date.date(event.detail.value.day.value);
            this.send_at = date.format('YYYY-MM-DD');
        },
        setRecipientName : function (event) {
            this.newRecipient.name = event.target.value;
        },
        setRecipientEmail : function (event) {
            this.newRecipient.email = event.target.value;
        },
        setRecipients : function (event) {
            let self = this;
            this.newContact = false;
            var recipients = event.detail.value;
            if (!Array.isArray(recipients)) {
                recipients = recipients.split(',');
            }
            this.recipients = recipients;
            _.each(recipients, function (r) {
                if (r == 0) {
                    self.newContact = true;
                }
            });
        },
        clearMessage : function () {
            this.title      = '';
            this.message    = '';
            this.type       = '';
            // this.recipients = [];
            this.send_at    = moment().endOf('year').add(1, 'day').format('YYYY-MM-DD');
        },
        uploaded : function () {
            let self = this;
            this.errorCount = 0;
            self.uploading = false;
            self.posting = false;
            this.chunks = [];
            this.percent = 100;
            this.thumbnail = null;
            var msg = 'Your message has been added and will be sent on ' + moment(self.send_at).format('Do MMMM YYYY');
            self.showSuccess(msg, function () {
                self.clearMessage();
                self.checkSpace();
            });
        },
        nextChunk : function (num, message_id) {
            let self      = this,
                chunk     = this.chunks[num],
                chunk_num = num + 1,
                count     = _.size(this.chunks);

            console.debug(num + ' of ' + count);

            // send the first one, but stop once its uploaded them all
            if (num > 0 && chunk_num > count) {
                this.uploaded();
                this.posting = false;
                return;
            }

            self.percent = _.ceil(100 * ((chunk_num) / this.chunkCount));

            this.axios.post(self.api + 'messages/' + message_id + '/chunk', {
                chunk        : chunk,
                chunk_number : chunk_num,
                chunks       : count                                            // eslint-disable-next-line
            }).then(response => {
                console.debug('SENT CHUNK ' + chunk_num + ' OF ' + count);
                if (response.data.status == 'uploaded' || response.data.status == 'pending') {
                    self.uploaded();
                    return;
                }
                self.nextChunk(chunk_num, message_id);
            }).catch(error => {
                if (self.errorCount > 3) {
                    console.error('COULD NOT SEND CHUNK ' + chunk_num);
                    self.errorCount = 0;
                    self.uploading = false;
                    self.posting = false;
                    self.chunks = [];
                    self.showError('There was a problem uploading that file.  Please try again later');
                    return;
                } else {
                    console.debug('ERROR - RETRYING CHUNK ' + chunk_num + ' OF ' + count);
                    // try again if it failed
                    setTimeout(function () {
                        self.nextChunk(num, message_id)
                    }, 50);
                    self.errorCount = self.errorCount + 1;;
                }
                console.error('error sending chunk', error);
            });
        },
        splitString : function (str, size) {
            var re = new RegExp('.{1,' + size + '}', 'g');
            return str.match(re);
        },
        getChunks : function (message_id) {
            let self = this;
            var reader = new FileReader();
            reader.onload = function(e) {
                let str    = e.target.result,
                    chunks = self.splitString(str, self.chunkSize);

                self.chunks     = chunks;
                self.chunkCount = chunks.length;
                self.preparing = false;
                self.nextChunk(0, message_id);
            };
            reader.readAsDataURL(this.media);
        },
        sendMain : function (params) {
            let self = this;
            console.debug('SENDING', Date.now(), params);
            this.axios.post(this.api + 'messages', params)
                .then(response => {

                    self.uploading = true;
                    let message_id = response.data.id;
                    if (self.type == 'text') {
                        self.uploaded();
                        self.posting = false;
                        return;
                    }
                    self.getChunks(message_id);
                })
                .catch(error => {
                    console.error('Could not add message', error);
                    self.showError('We could not send that message.  Please check the information you provided and try again');
                    self.bytesSent = self.bytesToSend;
                });
        },
        extension : function (filename) {
            return (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename) : 'plain';
        },
        sendMessage : function () {
            // @todo validate!
            // @todo check size versus space.
            let self = this;
            this.percent = 0;
            this.posting = true;

            let recipients = [];
            if (!Array.isArray(this.recipients)) {
                this.recipients = [this.recipients];
            }
            _.each(this.recipients, function (recipient) {
                if (recipient != 0) {
                    var contact = _.find(self.contacts, function (contact) {
                        return contact.id == recipient;
                    });
                    if (contact) {
                        recipients.push({
                            id    : contact.id,
                            name  : contact.name,
                            email : contact.email
                        });
                    }
                }
            });
            if (this.newRecipient.name != '' && this.newRecipient.email != '') {
                recipients.push(this.newRecipient);
            }

            // console.log(recipients);
            if (_.size(recipients) == 0) {
                this.showError('You did not select any recipients');
                this.posting = false;
                return;
            }

            let mime = 'text/plain',
                size = 0,
                chunks = 0,
                thumbnail = null;
            if (this.type != 'text') {
                size   = this.media.size;
                mime   = this.media.type;

                // fudge the mime if it's empty.  This will give something like audio/wav
                if (!mime) {
                    mime = this.type + '/' + this.extension(this.media.name);
                }

                // approximate the number of chunks at this point.  Once we start
                // sending the chunks we'll know the exact number of chunks we
                // need to send.  This should be almost bang on because bytes
                // are about 75% of the base64 size
                var b64_bytes = ((size / 75) * 100) + 25;
                chunks = _.ceil(b64_bytes / this.chunkSize);
                this.preparing = true;
            }
            this.bytesToSend = size;
            this.bytesSent = 0;
            this.chunkCount = chunks;

            let params = {
                title      : this.title,
                message    : this.message,
                type       : this.type,
                send_at    : this.send_at,
                recipients : recipients,
                mime       : mime,
                chunks     : chunks,
                bytes      : size
            }
            if (this.space.purchased == 0 || this.space.available < size) {
                this.showWarning('Upgrade!', 'You will need to upgrade before you can send this message.', function () {
                    self.upgrading = true;
                    self.posting = false;
                });
            } else {
                this.sendMain(params);
            }
        },
        cancelUpgrade : function () {
            this.upgrading = false;
        },
        hasUpgraded : function () {
            let self = this;
            this.upgrading = false;
            this.loaded.space = false;
            this.axios.get(this.api + 'users/space')
                .then(response => {
                    self.space = response.data;
                    self.loaded.space = true;
                    self.sendMessage();
                })
                .catch(error => {
                    console.error('error setting space', error);
                });
        }
    }
}
</script>